const COMMENTS = [
  {
    name: '电影爱好者阿杰',
    text: '6080影视真的良心！高清画质不缓冲，更新速度超快，流浪地球3刚下线这里就有了，推荐给身边所有朋友了。',
    time: '2天前',
    tag: '老用户',
  },
  {
    name: '周末观影人',
    text: '找了很久的经典老片在这里找到了，画质出乎意料的好。不用注册直接看，体验比那些VIP网站舒服多了。',
    time: '3天前',
    tag: '',
  },
  {
    name: '科幻迷小李',
    text: '科幻专区特别全，诺兰的全系列、星际穿越、银翼杀手都有，而且都是高清版本，每天来打卡找新片。',
    time: '5天前',
    tag: '',
  },
  {
    name: '带娃看电影',
    text: '终于找到适合给孩子看的动画片合集了，熊出没系列很全，画质清晰，播放流畅不卡顿，孩子很喜欢。',
    time: '1周前',
    tag: '新用户',
  },
  {
    name: '影评人老张',
    text: '作为影视爱好者，6080影视的片库深度让我惊喜。从国产新片到海外独立电影，分类清晰，片源质量稳定，免VIP免费看的体验无与伦比。',
    time: '1周前',
    tag: '',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            听听影迷们怎么说6080影视
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {COMMENTS.map((c, i) => (
            <div
              key={i}
              className={`flex flex-col p-5 rounded-lg bg-background-50 border border-background-200/60 ${
                i === 4 ? 'lg:col-span-1 sm:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold flex-shrink-0">
                  {c.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-medium text-foreground-800">{c.name}</span>
                    {c.tag && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                        {c.tag}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{c.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{c.text}</p>
              <div className="flex items-center gap-1 mt-3">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}